/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-empty-function */

import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Observable, Subscription } from 'rxjs';
import { combineLatest, filter, finalize, take, tap } from 'rxjs/operators';

import { CustomerStatusEnum } from '@hub-workspace/apps/logged-home/src/app/shared/enums/customer-status.enum';
import { ILoggedHomeAppState } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/logged-home-app-state.interface';
import { IUserTagsInterface } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/user-tags.interface';
import { HomeSituationTrackerService } from '@hub-workspace/apps/logged-home/src/app/shared/services/home-situation-tracker/home-situation-tracker.service';
import { UserProfileService } from '@hub-workspace/apps/logged-home/src/app/shared/services/user-profile/user-profile.service';
import { UserTagAction } from '@hub-workspace/apps/logged-home/src/app/state-management/user-tag/user-tag.action';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { ModalComponent } from '@toro/common/shared/components/modal/modal.component';
import { DocumentTypeUserEnum } from '@toro/common/shared/enum/document-type-user.enum';
import { HomeStatus } from '@toro/common/shared/enum/home-status.enum';
import { RegistrationStatus } from '@toro/common/shared/enum/registration-status.enum';
import { RolesUser } from '@toro/common/shared/enum/roles-user.enum';
import { SuitabilityProfilesEnum } from '@toro/common/shared/enum/suitability/suitability-profiles.enum';
import { getFirstWord, getProfileDisplayName } from '@toro/common/shared/resources/profile.utils';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { FinancePosition } from '@toro/common/shared/models/pos-risk/finance-position';
import { User } from '@toro/common/shared/models/User';
import { AppcuesOnboardingObserver } from '@toro/common/shared/services/appcues/ng/observer.service';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { Icvm617Service } from '@toro/common/shared/services/icvm-617';
import { BackendToFrontendParserService } from '@toro/common/shared/services/parser/backend-to-frontend-parser.service';
import { REREGISTRATION_MESSAGES } from '@toro/common/shared/services/re-registration/user-re-registration.service';
import { SantanderSuitabilityService } from '@toro/common/shared/services/santander-suitability/santander-suitability-service';
import { StorageService } from '@toro/common/shared/services/storage.service';
import { UserSantanderService } from '@toro/common/shared/services/users/user-santander.service';
import { FinanceActions } from '@toro/common/shared/state-management/finance/finance.action';
import { SuitabilitySantanderAction } from '@toro/common/shared/state-management/suitability-santander/suitability-santander.action';
import { SuitabilityState } from '@toro/common/shared/state-management/suitability/suitability.reducer';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { UserAcceptCampaignActions } from '@toro/common/shared/state-management/user-accept-campaign/user-accept-campaign.actions';
import { UserProfileActions } from '@toro/common/shared/state-management/userprofile/userprofile.actions';
import { UserProfileState } from '@toro/common/shared/state-management/userprofile/userprofile.reducer';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { DebitBalanceService } from '../../../shared/services/toro-lumen/debit-balance.service';
import { Tag } from '../../../state-management/user-tag/user-tag.reducer';
import { ProjectedBalanceComponent } from '../components/projected-balance/projected-balance.component';
import { CheckingAccountReceiptComponent } from '../dialogs/checking-account-receipt/checking-account-receipt.component';
import { SuitabilityAnticipationDialogComponent } from '../dialogs/suitability-santander-anticipation-dialog/suitability-anticipation-dialog.component';
import { UserAcceptCampaignComponent } from '../dialogs/user-accept-campaign-dialog/user-accept-campaign-dialog.component';
import { HomeTraderBalanceComponent } from '../screens/home-trader/home-trader-balance/home-trader-balance.component';
import { OneViewExperienceVariant } from '../../../shared/modules/customer-wallet/services/oneview-experience-variant/oneview-experience-variant.util';
import { OneViewExperienceVariantService } from '../../../shared/modules/customer-wallet/services/oneview-experience-variant/oneview-experience-variant.service';

const cblcList = require('./../../../shared/assets/base-cblc-list.json');

@AutoUnsubscribe()
@Component({
  selector: 'home-logged-shell',
  templateUrl: './home-logged-shell.component.html',
  styleUrls: ['./home-logged-shell.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [AppcuesOnboardingObserver, DatePipe],
})
export class HomeLoggedShellComponent
  extends DisposableSafelly
  implements OnInit, AfterViewInit
{
  public oneViewExperienceVariant$: Observable<OneViewExperienceVariant>;
  public auth$: Observable<UsersState>;
  public user$: Observable<UserProfileState>;

  @ViewChild('modalUserRegister', { static: true })
  public modalUserRegister: ModalComponent;

  @ViewChild('pageTop', { static: true })
  public pageElement: ElementRef<HTMLDivElement>;

  public isTrader: boolean;
  public userAcceptCampaignData: any = [];
  public user: User;
  public userCblc: string;
  public isUserActive: boolean = false;
  public homeRole: HomeStatus;
  public userRoles = RolesUser;
  public homeStatus = HomeStatus;
  public selectedTabId: number;
  public isNegativeOnD0: boolean;
  public totalNetEquity: number;
  public availableBalance: number;
  public reregistrationMessage: (typeof REREGISTRATION_MESSAGES)[0];
  public showModalIntegrationPi: boolean;
  public isShowValue: boolean = true;
  public isDisplayBalance: boolean = true;
  public routeName: string;
  public showInfoValues: boolean = true;
  public pendingBalance: boolean = true;
  public requestTradeError: boolean;
  public hasDebitBalanceToBeFined: boolean;
  public debitValueToBeFined: number;
  public rolloutCblcNumbers: Array<number> = [5, 6];
  public cookieTraderStatus: string;
  public isTraderRoute: boolean;
  public userTags: Tag[];
  public userProfile: string | number;
  public userAuth: any;
  public userStore: any;
  public isLoaded: boolean;
  public cookieExclusiveStatus: string;
  public isExclusive: boolean;
  public isDarkMode: boolean;
  public isActiveAccount: boolean;
  public projectedFinance: number;
  public projetedFinanceColor = '#FFF';
  public titleColor: string = '#FFFFFF';
  public productAreaOrigin: string;
  public greetingName: string;
  public accessedByName: string;
  public isPJRepresentation: boolean;
  private dialogSubscription: Subscription;
  private pathnameSubscription: Subscription;

  private data: {
    userFinancePosition: FinancePosition;
    userConsolidatePosition: any;
    debitValue: number;
    productAreaOrigin: string;
  };

  constructor(
    private store: Store<AppState>,
    private tagStore: Store<ILoggedHomeAppState>,
    private userProfileService: UserProfileService,
    private backendToFrontendParserService: BackendToFrontendParserService,
    private dialogsService: DialogsService,
    public router: Router,
    private cd: ChangeDetectorRef,
    private icvm617Service: Icvm617Service,
    private datePipe: DatePipe,
    private debitBalanceService: DebitBalanceService,
    private userSantanderService: UserSantanderService,
    private santanderSuitabilityService: SantanderSuitabilityService,
    private oneViewExperienceVariantService: OneViewExperienceVariantService,
    private homeSituationTracker: HomeSituationTrackerService
  ) {
    super();
    this.oneViewExperienceVariant$ = this.oneViewExperienceVariantService.variant$;
    this.cookieTraderStatus = StorageService.getCookie('hubUserTraderStatus');
    this.cookieExclusiveStatus = StorageService.getCookie(
      'hubUserExclusiveStatus'
    );
    this.isExclusive = this.cookieExclusiveStatus == 'true';
    this.isTrader = this.cookieTraderStatus == 'true';
    this.isTraderRoute = this.router.url === '/trader';
    // this.isDarkMode = (this.isExclusive && this.isTrader) || (!this.isExclusive && this.isTrader) || (this.isExclusive && !this.isTrader) || this.isTrader;
    this.isDarkMode = true;
  }

  public ngOnInit() {
    this.getHideInfoFromStorage();
    this.callDispatchs();

    this.store
      .select(({ userProfile, suitability }) => ({
        user: userProfile.user,
        suitability,
      }))
      .pipe(
        combineLatest(
          this.store.select(({ finance }) => finance),
          this.store.select(({ authentication }) => authentication.currentUser)
        ),
        filter(
          ([
            {
              user: { profile },
            },
            { finance },
            currentUser,
          ]) => !!profile && !!finance && !!currentUser
        )
      )
      .subscribe(
        ([
          { user, suitability },
          { finance, consolidatePosition: consolidated },
          { cblc },
        ]) => {
          this.user = user;
          this.greetingName = getFirstWord(getProfileDisplayName(user));
          this.isPJRepresentation = (user as any)?.isRepresentation === true;
          if (this.isPJRepresentation) {
            this.accessedByName = getFirstWord((user as any)?.representativeName || this.accessedByName);
          }
          this.userProfile = user.profile;
          this.isUserActive = this.isActiveUser(this.userProfile);
          this.userCblc = cblc;
          this.isNegativeOnD0 = finance.availableOnAccountD0 < 0;
          this.isDisplayBalance = consolidated.totalNetEquity !== 0;
          this.totalNetEquity = consolidated.totalNetEquity;
          this.availableBalance = finance.balanceD0;
          this.data = {
            userFinancePosition: finance,
            userConsolidatePosition: consolidated,
            debitValue: this.debitValueToBeFined,
            productAreaOrigin: this.productAreaOrigin,
          };
          this.projectedFinance =
            finance.projectedD1 +
            finance.projectedD2 +
            finance.projectedD3 +
            finance.projectedDM3;
          this.defineHomeRole(this.user, suitability);
          this.checkReRegistrationAlert();

          const dateMax = new Date(2147483647 * 1000);

          StorageService.setCookie(
            'hubUserStatus',
            this.homeRole.toString(),
            dateMax
          );

          this.pendingBalance = false;
          if (this.cookieTraderStatus.length) {
            this.checkTraderProfile(this.userProfile);
          }

          this.homeSituationTracker.track(this.homeRole, {
            userKey: this.userCblc,
            productAreaOrigin: this.getHomeProductAreaOrigin(),
          });

          if (!this.isDarkMode) {
            this.projetedFinanceColor = '#000';
            this.titleColor = '#EAE7EE';
          } else if (this.isDarkMode) {
            this.projetedFinanceColor = '#fff';
          }

          if (this.projectedFinance > 0) {
            this.projetedFinanceColor = this.isDarkMode ? '#00FFCD' : '#006D51';
          } else if (this.projectedFinance < 0) {
            this.projetedFinanceColor = this.isDarkMode ? '#FA8E96' : '#A3141E';
          }
        }
      );

    this.disposableSubscriptions.push(
      this.store
        .select((state) => state.suitabilitySantander)
        .pipe(filter((r) => !!r))
        .subscribe((r) => {
          const hasProfile =
            r.profile &&
            r.profile.profileName &&
            r.profile.profileName.trim() !== '';
          if (!hasProfile) {
            this.showSuitabilityAnticipationModal();
          }
        })
    );

    this.auth$ = this.store.select((s) => s.authentication);

    this.auth$.pipe(filter((data) => !!data.currentUser)).subscribe((data) => {
      this.userAuth = { ...data };
      this.accessedByName = getFirstWord((data.currentUser as any)?.name);
    });

    this.user$ = this.store.select((s) => s.userProfile);

    this.user$.subscribe((user) => (this.userStore = user));

    this.tagsSubscribe();

    if (!this.cookieTraderStatus || this.cookieTraderStatus === '') {
      this.store.dispatch({ type: UserTagAction.getUserTag });
    }

    this.disposableSubscriptions.push(
      this.icvm617Service.mustShowNotification().subscribe((result) => {
        if (result.mustShowNotification) {
          this.showDialogWarningIcvm617(result.userBlocked);
        }
      })
    );

    this.userSantanderService
      .getSantanderOperationalLimit(this.userCblc)
      .subscribe((limit) => {
        if (limit.isSantanderCustomer && limit.accept) {
          //Caso seja cliente santander e tenha aceitado a integração, não faz nada
          this.hasDebitBalanceToBeFined = false;
        } else {
          this.debitBalanceService
            .getDebitBalance()
            ?.pipe(
              tap((debit) => {
                this.hasDebitBalanceToBeFined = debit.data.mayBeFinedTomorrow;
                this.debitValueToBeFined = debit.data.value;
              })
            )
            .subscribe({
              next: () => {
                if (this.hasDebitBalanceToBeFined) {
                  this.sendTracking('Element Loaded', {
                    'Product Area Origin':
                      !this.isExclusive && !this.isTrader
                        ? 'Home Investidor'
                        : 'Home Exclusiva',
                    'Time Responsável': 'Roebling',
                    Element: 'Alerta saldo insuficiente',
                    Text: 'Regularize seus débitos até o fechamento do dia',
                  });
                }
              },
              error: (error) => {
                console.error('Error fetching debit balance:', error);
              },
            });
        }
      });
  }

  public callDispatchs() {
    this.store.dispatch({
      type: UserAcceptCampaignActions.getUserAcceptCampaign,
    });
    this.store.dispatch({ type: UserProfileActions.getUser });
    this.store.dispatch({ type: FinanceActions.getFinancePosition });
    this.store.dispatch({ type: FinanceActions.getConsolidatePosition });
    this.store.dispatch({ type: FinanceActions.getRealtimeFinancePosition });
    this.store.dispatch({
      type: FinanceActions.getRealtimeConsolidatedPosition,
    });
    this.store.dispatch({
      type: SuitabilitySantanderAction.getProfileSantander,
    });
    this.store.dispatch({
      type: SuitabilitySantanderAction.checkClientExcludeFromCommunication,
    });

    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: {
        type: 'Loaded a Page',
        events: {
          action: ActionEventsEnum.VIEW,
          platform: 'Hub Logged Home',
        },
      },
    });
  }

  public ngAfterViewInit() {
    this.disposableSubscriptions.push(
      this.store
        .select((state) => state.userAcceptCampaign)
        .pipe(filter((data) => !!data))
        .subscribe((data) => {
          this.userAcceptCampaignData = data.userAcceptCampaignData;
          this.userAcceptModal();
        })
    );
  }

  /**
   * Determina o cenário de home do usuário
   *
   * @param user
   */
  public defineHomeRole(
    {
      profile: customerStatus,
      registrationStatus,
      documents,
    }: Partial<User> & { documents?: any[] },
    suitability: SuitabilityState
  ) {
    const registrationStatusEnum =
      this.backendToFrontendParserService.parseRegistrationStatus(
        registrationStatus
      );

    switch (customerStatus as RolesUser) {
      // Cenário de usuários ativos
      case RolesUser.Activated: {
        if (this.isNegativeOnD0 || this.totalNetEquity < 0) {
          this.homeRole = this.homeStatus.ActivatedNegative;
        } else {
          this.homeRole = HomeStatus.Activated;
        }
        return this.homeRole;
      }

      // Cenários de usuários registrados
      case RolesUser.Registered: {
        return (this.homeRole = HomeStatus.RegisteredWithoutMoney);
      }

      // Cenário de usuários identificados
      case RolesUser.Identified: {
        this.isDarkMode = false;

        switch (registrationStatusEnum) {
          case RegistrationStatus.CreatingAccount: {
            return (this.homeRole = HomeStatus.UserIdentified);
          }
          case RegistrationStatus.LoginWithoutAccount: {
            return (this.homeRole = HomeStatus.UserNotFilling);
          }

          case RegistrationStatus.RegisteredUser: {
            this.isDarkMode = true;
            return (this.homeRole = HomeStatus.RegisteredWithoutMoney);
          }

          default: {
            const hasDocuments =
              documents &&
              documents.some(
                ({ documentTypeGUID }) =>
                  documentTypeGUID === DocumentTypeUserEnum.CE
              );
            const hasSuitability =
              suitability.profile &&
              suitability.profile.profile !== SuitabilityProfilesEnum.NoProfile;
            if (registrationStatusEnum === RegistrationStatus.ExternalIssues) {
              return (this.homeRole = hasDocuments
                ? HomeStatus.RegisteredExternalIssuer
                : HomeStatus.RegisteredSendDocs);
            } else {
              const statusBySuitabilityAndDocuments = hasSuitability
                ? HomeStatus.RegisteredDocsSended
                : HomeStatus.RegisteredDocsSendedWithoutSuitability;
              return (this.homeRole = hasDocuments
                ? statusBySuitabilityAndDocuments
                : HomeStatus.RegisteredWithoutDocs);
            }
          }
        }
      }

      default: {
        return (this.homeRole = HomeStatus.UserNotFilling);
      }
    }
  }

  public checkReRegistrationAlert() {
    this.reregistrationMessage =
      REREGISTRATION_MESSAGES[this.user.registrationStatus];
    if (this.reregistrationMessage && this.modalUserRegister) {
      this.modalUserRegister.show();
    }
  }

  public onCloseModalIntegrationPi(event: boolean) {
    this.showModalIntegrationPi = event;
  }

  private showDialogWarningIcvm617(userBlocked: boolean) {
    this.icvm617Service
      .getUserExpirationDate()
      .subscribe((dateExpiration: Date) => {
        const messageWarning = `<p>De acordo com a nova instrução CVM 617, precisamos que atualize algumas informações <b>até o dia
                ${this.datePipe.transform(
                  dateExpiration,
                  'dd/MM'
                )}</b>, para que sua conta não seja <b>bloqueada de fazer novas operações</b>.

                <br/> <br/>
                A atualização é simples e leva menos de 2 minutos.</p><br/>`;

        const messageUserBlocked = `<p>A Resolução CVM 50 exige que todos os clientes estejam com os dados cadastrais atualizados. Por isso, sua conta está temporariamente bloqueada para novas operações.

                <br/> <br/>
                Por favor, atualize seu cadastro para voltar a investir.</p><br/>`;

        this.dialogsService
          .confirmDestructiveAction(
            'Atualize seus dados para continuar a investir',
            userBlocked ? messageUserBlocked : messageWarning,
            'Atualizar dados cadastrais',
            'Deixar para depois'
          )
          .pipe(
            finalize(() => {
              this.icvm617Service.setUserViewedNotification();
            })
          )
          .subscribe((data) => {
            if (data) {
              this.router.navigate(['minha-conta/risco/edit']);
            }
          });
      });
  }

  public userAcceptModal() {
    if (this.userAcceptCampaignData.length > 0) {
      this.dialogSubscription = this.dialogsService
        .showComponnent(
          UserAcceptCampaignComponent,
          this.userAcceptCampaignData[0]
        )
        .afterClosed()
        .subscribe((confirm) => {
          const guidContrato: string =
            this.userAcceptCampaignData[0].guidContrato;
          this.userAcceptCampaignData.splice(0, 1);
          if (confirm) {
            this.store.dispatch({
              type: UserAcceptCampaignActions.putUserAcceptCampaign,
              guidContrato: guidContrato,
            });
          }
        });
    }
  }

  public showSuitabilityAnticipationModal() {
    const shouldShowModal =
      this.santanderSuitabilityService.mustShowCommunication() &&
      this.santanderSuitabilityService.mustShowPostLoginCommunication();

    if (shouldShowModal) {
      const lastShown = localStorage.getItem('suitabilityModalLastShown');
      const today = new Date().toDateString();

      if (lastShown !== today) {
        StorageService.setLocalItem('suitabilityModalLastShown', today);
        this.disposableSubscriptions.push(
          this.dialogsService
            .showComponnent(SuitabilityAnticipationDialogComponent, {
              isTrader: this.isTrader,
              IsExclusive: this.isExclusive,
            })
            .afterClosed()
            .subscribe(() => {})
        );
      }
    }
  }

  /**
   * Switch do perfil do usuário (investidor ou trader)
   * @param event boolean
   * @returns boolean
   */
  public changeIntend(event: boolean) {
    this.isTrader = event;
    this.isTraderRoute = this.isTrader;
    this.changeLocationByProfile();
    this.sendTracking('Element Clicked', {
      'Product Area Origin': 'Home Trader',
      'Time Responsável': 'Brooklyn Dumbo',
      Element: 'Switch',
      Group: !this.isTrader ? 'Investidor' : 'Trader',
    });

    // if(!this.isExclusive) {
    //   this.isDarkMode = !this.isDarkMode;
    // }

    return this.isTrader;
  }

  /**
   * Change url path by trader profile
   */
  public changeLocationByProfile() {
    StorageService.setCookie(
      'hubUserTraderStatus',
      this.isActiveUser(this.userProfile) ? this.isTrader.toString() : 'false'
    );
    if (this.isTrader) {
      this.router.navigate(['/trader'], { replaceUrl: true });
    } else {
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }

  /**
   * Change navigate by trader profile or just set cookie
   */
  public checkTraderProfile(
    profile: string | number,
    tags: IUserTagsInterface[] = []
  ) {
    if (!this.isActiveUser(profile)) {
      this.redirectToUnactivatedHome(profile, tags);
      return;
    }

    if (this.isTrader && this.router.url == '/') {
      this.redirectToTraderRouteAndSetTrader();
      return;
    }

    if (this.isTraderRoute) {
      this.isTrader = true;
      StorageService.setCookie('hubUserTraderStatus', this.isTrader.toString());
    }
  }

  public redirectToUnactivatedHome(
    profile: string | number,
    tags: IUserTagsInterface[]
  ) {
    this.isTrader = false;
    StorageService.deleteCookie('hubUserTraderStatus');

    if (profile === CustomerStatusEnum.REGISTERED) {
      this.userProfileService.redirectByProfile(profile, tags);
    } else {
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }

  public redirectToTraderRouteAndSetTrader() {
    StorageService.setCookie('hubUserTraderStatus', this.isTrader.toString());
    this.router.navigate(['/trader']);
  }

  /**
   * Recebe as UserTags que esse cliente possui.
   */
  public tagsSubscribe() {
    this.tagStore
      .select((state: any) => state.userTag)
      .pipe(
        combineLatest(this.store.select((state: any) => state.userProfile)),
        filter(([userTag, userProfile]) => !!userTag?.tags && !userTag.pending && !!userProfile?.user?.profile),
        take(1)
      )
      .subscribe(([userTag, userProfileState]) => {
        const tags = userTag.tags;
        const isTier = this.userProfileService.isTierTrader(tags);
        const cookie = StorageService.getCookie('hubUserTraderStatus');

        if (isTier && (!cookie || cookie === '')) {
          this.isTrader = true;
          this.isTraderRoute = true;
          StorageService.setCookie('hubUserTraderStatus', 'true');
          this.cd.detectChanges();
          this.router.navigate(['/trader'], { replaceUrl: true });
        } else {
          this.isTrader = cookie === 'true';
          this.checkTraderProfile(userProfileState.user.profile, tags);
          this.cd.detectChanges();
        }

        this.checkRequestError(userTag);
      });
  }

  /**
   * Busca do localstorage a config de privacidade que o usuário deixou.
   */
  public getHideInfoFromStorage() {
    const showInfo = window.localStorage.getItem('showTraderInfoValues');
    if (showInfo && showInfo === 'false') {
      this.showInfoValues = false;
    } else {
      this.showInfoValues = true;
    }
  }

  /**
   * Método que mostra/esconde os valores do usuario
   */
  public toggleHideInfo() {
    this.showInfoValues = !this.showInfoValues;
    if (this.showInfoValues === true) {
      window.localStorage.setItem('showTraderInfoValues', 'true');
      window.localStorage.setItem('showInvestorInfoValues', 'true');
    } else {
      window.localStorage.setItem('showTraderInfoValues', 'false');
      window.localStorage.setItem('showInvestorInfoValues', 'false');
    }
  }

  /**
   * Verifica se houve um erro na hora de buscar uma tag.
   */
  public checkRequestError(userTag) {
    if (userTag.userTagError) {
      this.requestTradeError = true;
    }
  }

  public balanceSidePanel() {
    this.dialogsService.showComponentAsAsidePanel(
      HomeTraderBalanceComponent,
      true,
      this.data
    );

    this.sendTracking('Element Clicked', {
      'Product Area Origin': 'Home Trader',
      'Time Responsável': 'Roebling',
      Element: 'Índice patrimônio',
      Group: 'Informações da conta',
    });
  }

  public projectedBalanceSidePanel(origin?: string) {
    this.dialogsService.showComponentAsAsidePanel(
      ProjectedBalanceComponent,
      true,
      this.data
    );

    if (this.isExclusive) {
      this.productAreaOrigin = 'Home Exclusiva';
    } else if (this.isTrader) {
      this.productAreaOrigin = 'Home Trader';
    } else {
      this.productAreaOrigin = 'Home Investidor'; // Default for !isExclusive && !isTrader
    }

    if (origin == 'alert') {
      this.sendTracking('Element Clicked', {
        'Product Area Origin': this.productAreaOrigin,
        'Time Responsável': 'Roebling',
        Element: 'Link ver lançamentos futuros',
      });
    } else {
      this.sendTracking('Element Clicked', {
        'Product Area Origin': this.productAreaOrigin,
        'Time Responsável': 'Roebling',
        Element: 'Índice lançamentos futuros',
        Group: 'Informações da conta',
      });
    }
  }

  public trackPatrimonyTooltipClick(): void {
    this.sendTracking('Element Clicked', {
      'Product Area Origin': 'Home',
      'Time Responsável': 'Mezzo',
      Element: 'Tooltip',
      Group: 'Patrimônio',
      Step: 'Não se aplica',
      Scenario: this.isExclusive ? 'Exclusivo' : 'Varejo',
      Text: 'Não se aplica',
    });
  }

  /**
   * Resolve o Product Area Origin de acordo com o tipo de home do usuário.
   */
  public getHomeProductAreaOrigin(): string {
    if (this.isExclusive) {
      return 'Home Exclusiva';
    } else if (this.isTrader) {
      return 'Home Trader';
    }
    return 'Home Investidor';
  }

  /**
   * Rastreia o clique no botão de Saque, adaptando o Product Area Origin a cada tipo de home.
   */
  public trackWithdrawalClick() {
    this.sendTracking('Element Clicked', {
      'Product Area Origin': this.getHomeProductAreaOrigin(),
      'Time Responsável': 'Brooklyn Dumbo',
      Element: 'Saque',
    });
  }

  public sendTracking(event: string, breakdowns: any) {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: { type: event, events: breakdowns },
    });
  }

  public isActiveUser = (profile: string | number): boolean =>
    profile === RolesUser.Activated;

  public navTheme() {
    if (this.isDarkMode) {
      return 'darker';
    }

    return 'transparent';
  }

  /**
   * Método que abre o extrato do usuário
   */
  public openCheckingAccountReceipt() {
    this.sendTracking('Element Clicked', {
      'Product Area Origin': 'Home Trader',
      'Time Responsável': 'Brooklyn Dumbo',
      Element: 'Extrato',
    });
    this.dialogsService.showComponnent(CheckingAccountReceiptComponent, null);
  }

  public redirectGuarantees() {
    this.router.navigate(['/bolsa/meus-investimentos/garantias-disponiveis']);

    this.sendTracking('Element Clicked', {
      'Product Area Origin': 'Bolsa',
      'Time Responsável': 'Roebling',
      Step: 'Datas de cobrança',
      Scenario: 'Saldo insuficiente',
    });
  }

  public get isOnCblcList() {
    return cblcList.cblc.includes(this.userCblc);
  }
}
